import { render, staticRenderFns } from "./AllStock.vue?vue&type=template&id=afdc8e52&scoped=true&"
import script from "./AllStock.vue?vue&type=script&lang=js&"
export * from "./AllStock.vue?vue&type=script&lang=js&"
import style0 from "./AllStock.vue?vue&type=style&index=0&id=afdc8e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdc8e52",
  null
  
)

export default component.exports